export default "__VITE_ASSET__ZB30ZsGl__"